import React from "react";
import TabPane from "../../../components/Tab/TabPane";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonInputDate from "../../../components/forms/CommonInputDate";
import CommonInputValor from "../../../components/forms/CommonInputValor";
import CommonSelectMultiple from "../../../components/forms/CommonSelectMultiple";
import {
  handleChange,
  handleChangeMultipleSelect,
  handleChangeNameValue,
} from "../../../helpers/handleFormChanges";
import TabHelper from "../../../helpers/TabHelper";
import PropTypes from "prop-types";

function InformacoesTab({
  tabAtualHook,
  valuesHook,
  checkInformacoesTab,
  salvarInformacoes,
}) {
  const { values, setValues } = valuesHook;
  const { tabAtual, setTabAtual } = tabAtualHook;

  const metodosPagamento = [
    { nome: "PIX", descricao: "PIX" },
    { nome: "Transferência Bancária", descricao: "Transferência Bancária" },
  ];

  return (
    <TabPane>
      <div>
        <div className="row" style={{ paddingRight: "0px" }}>
          <div className="col-lg-4 mb-3">
            <CommonInputDate
              id="data"
              label="Data de referência"
              value={values.data}
              onChange={(e) => {
                handleChange(e, values, setValues);
              }}
              required
            />
          </div>
          <div className="col-lg-8 mb-3">
            <CommonSelectMultiple
              id="metodoPagamento"
              label="Método de pagamento"
              value={values?.metodoPagamento
                ?.map((metodo) =>
                  metodosPagamento.find((mp) => mp.nome === metodo)
                )
                .filter(Boolean)}
              data={metodosPagamento}
              onChange={(e, newValue) => {
                handleChangeMultipleSelect(
                  values,
                  setValues,
                  "metodoPagamento",
                  newValue,
                  "nome"
                );
              }}
              required
              optionLabel="descricao"
            />
          </div>
        </div>
        <div className="row" style={{ paddingRight: "0px" }}>
          <div className="col-lg-4 mb-3">
            <CommonInputValor
              label="Desconto"
              id="desconto"
              value={values.desconto}
              onChange={(e) => {
                handleChangeNameValue(
                  "desconto",
                  e.target.value,
                  values,
                  setValues
                );
              }}
            />
          </div>
        </div>
        <div className="row mb-3 mx-0 gap-3 justify-content-between">
          <CommonButton
            onClick={() => {
              TabHelper.trocarTab(tabAtual, setTabAtual, -1);
            }}
            color="primary"
          >
            Anterior
          </CommonButton>
          <CommonButton
            style={{
              paddingRight: "1.5rem",
              paddingLeft: "1.5rem",
            }}
            color="success"
            onClick={() => {
              if (checkInformacoesTab()) {
                salvarInformacoes();
              }
            }}
          >
            Emitir
          </CommonButton>
        </div>
      </div>
    </TabPane>
  );
}

InformacoesTab.propTypes = {
  tabAtualHook: PropTypes.shape({
    tabAtual: PropTypes.number.isRequired,
    setTabAtual: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  checkInformacoesTab: PropTypes.func.isRequired,
  salvarInformacoes: PropTypes.func.isRequired,
};

export default InformacoesTab;
